export default __webpack_public_path__ + "static/media/Blog12.5.c6905d44.png";